import { Link } from 'react-router-dom';
import type { Media } from '@/types/media';

interface MediaCardProps {
  item: Media;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      data-product-shop
      className="group flex flex-col overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:ring-accent-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}海报`}
          title={`${item.title} - 八戒影院影视内容`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-black/65 px-2 py-0.5 text-xs font-semibold text-secondary-400">
          <i className="ri-star-fill text-xs" />
          {item.rating.toFixed(1)}
        </span>
        {item.type === 'tv' && (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
            {item.episodes}集
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {item.genres.slice(0, 2).join(' · ')}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{item.region}</span>
          <span>{item.year}</span>
        </div>
      </div>
    </Link>
  );
}